<template>
  <div class="containerMaterialList">
    <div class="topOperation">
      <span v-if="!isModal">
        <a-button class="addBtn" type="primary" icon="plus" @click="addMaterial">添加材料</a-button>
        <a-button v-if="selectedRowKeys && selectedRowKeys.length === 0 && !isShowMoreops" @click="toggleBatchOpsion" type="link">
          <a-icon :component="IconMoreops" />
          批量操作
        </a-button>
        <div v-else style="display: inline-block;">
          <a @click="cancelBatch"><a-icon style="margin-right: 5px;" :component="arrowLeft" />取消</a>
          <a-divider type="vertical"></a-divider>
          <a @click="deleteHandle()"><a-icon style="margin-right: 5px;" type="delete" />删除</a>
        </div>
      </span>
      <a-input-search allowClear @search="searchForName" placeholder="搜一搜文件名称" :class="!isModal ? 'inputSearch' : ''"></a-input-search>
    </div>
    <a-table
      :class="!isModal ? 'haveBottom' : ''"
      :columns="columns"
      :row-key="record => record.iid"
      :data-source="dataSource"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <template slot="fileName" slot-scope="text, record">
        <a-input v-if="record.isReName" @keydown.enter="nameSave(record)" v-model="record.fileName"></a-input>
        <span v-else>{{ text }}</span>
      </template>
      <template slot="fileSize" slot-scope="text, record">
        <span>{{ record.fileSize }} MB</span>
      </template>
      <template slot="utime" slot-scope="text, record">
        <span>{{ record.utime | filterTime }}</span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="previewHandle(record)">预览</a>
        <span v-if="!isModal">
          <a-divider type="vertical" />
          <a v-if="!record.isReName" @click="reNameHandle(record)">重命名</a>
          <a v-else @click="nameSave(record)">保存</a>
          <a-divider type="vertical" />
          <a @click="deleteHandle(record)">删除</a>
        </span>
      </span>
    </a-table>
    <!-- 空数据展示 -->
    <a-empty :class="!isModal ? 'haveBottom' : ''" v-if="dataSource.length === 0" :image="noMaterial" :description="false" :imageStyle="{ width: '240px', height: '203px' }" />
    <!-- 添加材料弹窗 -->
    <add-material ref="addMaterial"></add-material>
  </div>
</template>

<script>
import IconMoreops from '@/assets/IconBatch.svg?inline'
import noMaterial from '@/assets/noMaterial.png?inline'
import arrowLeft from '@ant-design/icons/svg/outline/arrow-left.svg?inline'
import AddMaterial from './AddMaterial.vue'
import { jiopAPI } from '@/api/jiopweb/jiop'
// import { axios } from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'MaterialList',
  components: {
    AddMaterial
  },
  props: {
    // 是否弹窗中展示
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      IconMoreops,
      noMaterial,
      arrowLeft,
      selectedRowKeys: [],
      isShowMoreops: false,
      // pagination: {
      //   current: 1,
      //   pageSize: 10, // 默认每页显示数量
      //   size: 'small',
      //   showSizeChanger: true, // 显示可改变每页数量
      //   showQuickJumper: true,
      //   showTotal: total => `共 ${total} 条记录`, // 显示总数
      //   onShowSizeChange: (current, pageSize) => this.onSizeChange(current, pageSize), // 改变每页数量时更新显示
      //   onChange: (page, pageSize) => this.onPageChange(page, pageSize), // 点击页码事件
      //   total: 0 // 总条数
      // },
      columns: [
        {
          title: '文件名',
          dataIndex: 'fileName',
          key: 'fileName',
          width: this.isModal ? 300 : 500,
          scopedSlots: { customRender: 'fileName' }
        },
        {
          title: '大小',
          dataIndex: 'fileSize',
          key: 'fileSize',
          scopedSlots: { customRender: 'fileSize' }
        },
        {
          title: '更新时间',
          dataIndex: 'utime',
          key: 'utime',
          scopedSlots: { customRender: 'utime' }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      queryParams: {
        fileName: ''
      }
    }
  },
  filters: {
    filterTime (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // axios.defaults.headers['accessToken'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQxNzIyNTIsImlhdCI6MTY5NDE1NDI1MiwidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.sYz_sEmMH5_fdBuPEvo-97uR6FzdDeeTN6oBjA1tNfE'
      const data = {
        appType: 1
        // pageNo: this.pagination.current,
        // pageSize: this.pagination.pageSize
      }
      jiopAPI.usermaterialList({ ...this.queryParams, ...data }).then(res => {
        this.dataSource = res.data?.data || []
        // this.pagination.total = res.data.total
        this.$emit('getListNumber', res.data.total)
      })
    },
    // // 改变每页数量时更新显示
    // onSizeChange (current, pageSize) {
    //   this.pagination.current = current
    //   this.pagination.pageSize = pageSize
    //   this.init()
    // },
    // // 点击页码事件
    // onPageChange (page, pageSize) {
    //   this.pagination.current = page
    //   this.pagination.pageSize = pageSize
    //   this.init()
    // },
    toggleBatchOpsion () {
      this.isShowMoreops = true
    },
    cancelBatch () {
      this.selectedRowKeys = []
      this.isShowMoreops = false
    },
    addMaterial () {
      this.$refs.addMaterial.open()
    },
    onSelectChange (data, selecrd) {
      this.selectedRowKeys = data
      this.$emit('getSelectFile', selecrd)
    },
    searchForName (value) {
      this.queryParams.fileName = value
      // this.pagination.current = 1
      // this.pagination.pageSize = 10
      this.init()
    },
    // 重命名
    reNameHandle (record) {
      this.$set(record, 'isReName', true)
    },
    // 重命名保存
    nameSave (record) {
      const data = {
        iid: record.iid,
        fileName: record.fileName
      }
      jiopAPI.usermaterialModify(data).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          record.isReName = false
          this.init()
        }
      })
    },
    // 删除
    deleteHandle (record) {
      if (!record && this.selectedRowKeys.length === 0) {
        this.$message.warning('请勾选删除项')
        return
      }
      const _this = this
      this.$confirm({
        title: record || this.selectedRowKeys.length <= 1 ? '确定要删除该材料吗？' : '确定要删除这些材料吗？',
        onOk () {
          const data = {
            ids: '',
            userId: ''
          }
          if (_this.selectedRowKeys.length > 0) {
            data.ids = _this.selectedRowKeys.join()
          } else {
            data.ids = record.iid
          }
          jiopAPI.usermaterialDelete(data).then(res => {
            if (res.success) {
              _this.$message.success('删除成功')
            }
            // _this.pagination.current = 1
            // _this.pagination.pageSize = 10
            _this.init()
          })
        },
        onCancel () {

        }
      })
    },
    // 预览
    previewHandle (item) {
      jiopAPI.fileView({ filePath: item.fileUrl }).then(res => {
        if (res.success) {
          const url = '/api-gateway/common-hos-server/interface/file/previewFile?token=' + res.data.token + '&appid=' + res.data.hosAppId
          window.open(url)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.addBtn {
  height: 40px;
  margin-right: 20px;
}
.inputSearch {
  width: 352px;
}
.topOperation {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  /deep/ .ant-input {
    height: 40px;
  }
}
/deep/.ant-table-pagination.ant-pagination {
  text-align: center;
  float: inherit;
  margin-top: 30px;
  margin-bottom: 0px;
}
// 弹窗中才会有这个样式
.haveBottom {
  /deep/.ant-table-pagination.ant-pagination {
    margin-bottom: 40px;
  }
}
/deep/ .ant-btn-link {
  color: #666666;
  padding: 0px;
}
/deep/ .ant-table-placeholder {
  display: none;
}
/deep/ .ant-empty-image {
  height: 203px;
  width: 240px;
  margin: auto;
  margin-top: 102px;
  margin-bottom: 105px;
}
.haveBottom {
  /deep/ .ant-empty-image {
    margin-bottom: 305px;
  }
}
/deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
  padding: 14px 16px;
}
</style>
